/// <reference path="../../../../turbo/views/login/login.component.ts" />
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase } from 't4core';
import { SendMessageDialog } from '../../dialogs/SendMessageDialog/SendMessageDialog';


@Component({
    selector: 'inbox',
    templateUrl: './inbox.html',
    styleUrls: ['./inbox.css'],
})
export class InboxComponent extends PageBase implements OnInit {

    constructor(el: ElementRef) {
        super(el, "Messages");
    }

    ngOnInit() {
        
    }

    public new() {
        this.Dialog.open(SendMessageDialog, {});
    }
}
